export const colorsDentistry = {
  
    //  Default
    default_color: '#E0D5C6',
    selected_color: '#2EE093',
    stroke_color: '#000000'
  };